import { createContext } from "react";

const DF_CO0009Context = createContext();

export { DF_CO0009Context };